function readNumber(value) {
  if (value == null || value === "") return null;
  const parsed = Number(String(value).replace(",", "."));
  return Number.isFinite(parsed) ? parsed : null;
}

function readPayload(record) {
  return record && record.payloadData ? record.payloadData : {};
}

function workKeyFromPayload(payload, localId) {
  if (localId != null && localId !== "") return String(localId);
  if (payload.trabalho_id_local != null) {
    return String(payload.trabalho_id_local);
  }
  if (payload.nome_trabalho) return String(payload.nome_trabalho);
  return "sem-id";
}

function parseWorkRecord(record) {
  const payload = readPayload(record);
  const localId = record.local_id != null ? record.local_id : payload.id_local;
  return {
    key: workKeyFromPayload(payload, localId),
    localId,
    uuid: record.uuid,
    operatorName: record.operatorName || "—",
    receivedAt: record.received_at,
    name: payload.nome_trabalho || "Trabalho de insumos",
    operationType: payload.tipo_operacao || "—",
    machineName: payload.nome_maquina || "",
    baselinePanelHa: readNumber(payload.hectares_painel_inicial),
    baselineHourMeter: readNumber(payload.horimetro_inicial),
    targetFertilizer: readNumber(payload.taxa_alvo_adubo_kg_ha),
    targetSeed: readNumber(payload.taxa_alvo_semente_kg_ha),
    targetPesticide: readNumber(payload.taxa_alvo_defensivo_l_ha),
    startedAt: payload.iniciado_em_utc || record.received_at,
  };
}

function parseRefillRecord(record) {
  const payload = readPayload(record);
  const hectares = readNumber(payload.hectares_bacia);
  const fertilizerKg = readNumber(payload.adubo_kg);
  const seedKg = readNumber(payload.semente_kg);
  const pesticideL = readNumber(payload.defensivo_l);

  return {
    uuid: record.uuid,
    workKey: workKeyFromPayload(payload, payload.trabalho_id_local),
    operatorName: record.operatorName || "—",
    receivedAt: record.received_at,
    recordedAt: payload.registrado_em_utc || record.received_at,
    panelHa: readNumber(payload.hectares_painel),
    hourMeter: readNumber(payload.horimetro),
    hectares,
    fertilizerKg,
    seedKg,
    pesticideL,
    fertilizerKgHa:
      fertilizerKg != null && hectares > 0 ? fertilizerKg / hectares : null,
    seedKgHa: seedKg != null && hectares > 0 ? seedKg / hectares : null,
    pesticideLHa:
      pesticideL != null && hectares > 0 ? pesticideL / hectares : null,
    targetFertilizer: readNumber(payload.taxa_alvo_adubo_kg_ha),
    targetSeed: readNumber(payload.taxa_alvo_semente_kg_ha),
    targetPesticide: readNumber(payload.taxa_alvo_defensivo_l_ha),
  };
}

function isOutOfTarget(actual, target, tolerancePercent = 5) {
  if (actual == null || target == null || target <= 0) return false;
  return Math.abs(actual - target) / target > tolerancePercent / 100;
}

export function groupInputRefillRecords(workRows, refillRows) {
  const groups = new Map();

  (workRows || []).forEach((record) => {
    const work = parseWorkRecord(record);
    groups.set(work.key, {
      work,
      refills: [],
    });
  });

  (refillRows || []).forEach((record) => {
    const refill = parseRefillRecord(record);
    if (!groups.has(refill.workKey)) {
      groups.set(refill.workKey, {
        work: {
          key: refill.workKey,
          name: readPayload(record).nome_trabalho || `Trabalho ${refill.workKey}`,
          operationType: readPayload(record).tipo_operacao || "—",
          operatorName: refill.operatorName,
          receivedAt: record.received_at,
          targetFertilizer: refill.targetFertilizer,
          targetSeed: refill.targetSeed,
          targetPesticide: refill.targetPesticide,
        },
        refills: [],
      });
    }
    groups.get(refill.workKey).refills.push(refill);
  });

  return Array.from(groups.values())
    .map((group) => ({
      ...group,
      refills: group.refills.sort(
        (a, b) => new Date(b.recordedAt).getTime() - new Date(a.recordedAt).getTime()
      ),
    }))
    .sort(
      (a, b) =>
        new Date(b.work.receivedAt || 0).getTime() -
        new Date(a.work.receivedAt || 0).getTime()
    );
}

export function formatRate(value, unit) {
  if (value == null || Number.isNaN(value)) return "—";
  return `${Number(value).toLocaleString("pt-BR", {
    maximumFractionDigits: 1,
  })} ${unit}`;
}

export { isOutOfTarget };
